import { KatSpinner } from '@amzn/katal-react';
import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { applyTheme } from '@amzn/awsui-components-core/theming';
import { StencilProvider } from '@amzn/stencil-react-components/context';
import defaultStencilTokens from '@amzn/stencil-design-tokens/js/web/theme/stencilTheme';
import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, IntegratedChartsModule } from 'ag-grid-enterprise';
import { APP_THEME, FONT_FAMILY_BASE } from './constants/ThemeConstants';
import AppInitWrapper from './app/AppInitWrapper';

import { App } from './app/App';
import './index.scss';

// Mark the earliest point of JS execution for end-to-end page load measurement
performance.mark('xpt-page-load-start');

// Register AG Grid modules (required since v33). AllEnterpriseModule covers all community + enterprise features;
// IntegratedChartsModule.with(AgChartsEnterpriseModule) wires Integrated Charts per v33+ migration guide.
ModuleRegistry.registerModules([
  AllEnterpriseModule,
  IntegratedChartsModule.with(AgChartsEnterpriseModule),
]);

// Apply custom font to all Cloudscape components
applyTheme({ theme: APP_THEME });

// Override Stencil's default font (Amazon Ember) with Ember Modern Text to match Cloudscape theming
const STENCIL_THEME = {
  ...defaultStencilTokens,
  ':root': {
    ...defaultStencilTokens[':root'],
    '--st-dt-text-family-default': FONT_FAMILY_BASE,
  },
};

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOMClient.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <StencilProvider theme={STENCIL_THEME}>
        <AppInitWrapper>
          <React.Suspense fallback={<KatSpinner size="large" />}>
            <App />
          </React.Suspense>
        </AppInitWrapper>
      </StencilProvider>
    </React.StrictMode>
  );
}
